import './MessageHeader.scss'
import UserAvatar from '@components/UI/UserAvatar/UserAvatar'
import { formatDateLocale } from '@/app/utils/commonFunctions'
import { LuxIcon } from '@lux/wardrobe-lib'
import moment from "moment";
import {useEffect, useState} from "react";

const MessageHeader = (props: any) => {
    const { author, creationDate, isUnread, onEdit, canEdit } = props

    const componentClass = 'modals-new-activity-execution-message-header'

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__user-container`}>
                {author.name && (
                    <UserAvatar
                        userName={author.name}
                        userLastname={author.lastname}
                        userNickname={author.alias}
                        avatarImage={author.avatar}
                    />
                )}
                <div className={`${componentClass}__user-info`}>
                    <div className={`${componentClass}__user-name text-bold`}>
                        {author.alias ? author.alias: author.name}{author.alias ? '' : ' ' + author.lastname}
                    </div>
                    <div className={`${componentClass}__creation-date text`}>
                        {moment(creationDate).format('L LT')}
                    </div>
                </div>
                {isUnread && (
                    <div className={`${componentClass}__unread-container`}>
                        <div className={`${componentClass}__unread`}></div>
                    </div>
                )}
            </div>
            {canEdit && (
                <div className={`${componentClass}__edit-container`}>
                    <LuxIcon icon="pencil" onClick={onEdit} />
                </div>
            )}
        </div>
    )
}

export default MessageHeader
